// KL - yearly aircond servicing package.
const content = {
    slug: 'aircond-servicing-package',
    title: (c) => `Aircond Servicing Package KL from ${c.money(c.tables.annual[0].threeTimes)}/Year`,
    description: (c) =>
        `Yearly aircond servicing package in KL: 3 or 4 services a year at a fixed price, from ${c.money(c.tables.annual[0].threeTimes)} for one unit. Cheaper than booking each time.`,
    eyebrow: 'KL · Servicing package',
    h1: 'Aircond Servicing Package in KL',
    lead: (c) =>
        `Three or four general services a year, booked once at one fixed price. For one unit, ${c.money(c.tables.annual[0].threeTimes)} a year for three services - and the saving grows with every unit you add.`,
    image: 'blog/living/repairman-doing-air-conditioner-service.jpg',
    imageAlt: 'Technician on a scheduled aircond service visit in KL',
    facts: ['3 or 4 services a year', 'Fixed yearly price', 'Every unit in the house'],
    priceTitle: 'Package prices per year',
    priceIntro: 'Price covers all services in the year for wall-mounted units.',
    panel: { type: 'annual' },
    sections: [
        {
            title: 'Why a package suits KL homes',
            cards: [
                { title: 'Humidity never takes a break', body: 'Coils get dirty year-round here, not just in one season. Regular services prevent the smell and drips before they start.' },
                { title: 'Nobody has to remember', body: 'We remind you before each service and fix a date that suits you.' },
                { title: 'Good for landlords', body: 'If you rent out a condo, a package keeps units in shape between tenants and shows the upkeep in writing.' },
            ],
        },
        {
            title: 'Suggested timing',
            tone: 'muted',
            paragraphs: [
                'A three-service plan works well every four months - for example March, July and November, with the November visit before the year-end monsoon and festive season. A four-service plan, every three months, suits families with young children, allergies, or units running every night.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How much is an aircond servicing package in KL?',
            answer: (c) => `For one unit, ${c.money(c.tables.annual[0].threeTimes)} a year for three services or ${c.money(c.tables.annual[0].fourTimes)} for four. For three units, ${c.money(c.tables.annual[2].threeTimes)} a year for three services.`,
        },
        {
            question: 'Does the package include chemical wash or gas?',
            answer: 'The package covers general services. Chemical wash, overhaul and gas top up are quoted separately when needed, so you only pay for them if your unit actually needs them.',
        },
        {
            question: 'Is a package cheaper than booking each service?',
            answer: 'Yes - the yearly price is lower than three or four single bookings, and the discount grows with the number of units.',
        },
    ],
    schema: {
        name: 'Aircond Servicing Package in Kuala Lumpur',
        serviceType: 'Air conditioner maintenance plan',
        offers: (c) => [
            { name: 'Package, 1 unit, 3 services a year', price: c.tables.annual[0].threeTimes },
            { name: 'Package, 1 unit, 4 services a year', price: c.tables.annual[0].fourTimes },
            { name: 'Package, 3 units, 3 services a year', price: c.tables.annual[2].threeTimes },
        ],
    },
}

export default content
